import { MultiSelectorFecha } from "../../components/pickers/MultiSelectorFecha"
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { BotonProcesar } from "../../components/buttons/BotonProcesar"
import { Filtro } from "../../components/Filtro"
import { BotonNuevo } from "../../components/buttons/BotonNuevo"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { useProyectos } from "../../../hooks/proyectos/useProyectos"
import { useGeneral } from "../../../hooks/useGeneral"
import { useUsuarios } from "../../../hooks/usuarios/useUsuarios"
import { useEffect, useReducer, useState, useMemo, useContext } from "react"
import { agregarDias, formatDate, obtenerEstado, obtenerHoraActual, pintarFila, primeraLetraMayuscula, primeraLetraMayusculaOracion } from "../../../utils/utils"
import { LineaCarga } from "../../components/LineaCarga"
import { Tooltip } from "../../components/utils/Tooltip"
import { useModal } from "../../../hooks/useModal"
import { useSeguimientos } from "../../../hooks/seguimientos/useSeguimientos"
import { Modal } from "../../components/modal/Modal"
import { ModalProyecto } from "../../components/modal/ModalProyecto"
import { FasesProyecto } from "../../components/FasesProyecto"
import { NuevoSelectAutocomplete } from "../../components/forms/NuevoSelectAutocomplete"
import { MultiSelect } from "../../components/forms/MultiSelect"
import { DetalleProyecto } from "../../components/DetalleProyecto"
import { useEmpresas } from "../../../hooks/useEmpresas"
import { DatePickerABX } from "../../components/pickers/DatePicker"
import { ExportExcel } from "../../components/utils/ExportExcel"
import { ContenedorImagen } from "../../components/ContenedorImagen"
import { ContenedorDocumento } from "../../components/ContenedorDocumento"
import { useEntregables } from "../../../hooks/entregables/useEntregables"
import { useActividades } from "../../../hooks/actividades/useActividades"
import BarChartAbexa from "../../components/dashboard/BarChartAbexa"
import DoughnutProyecto from "../../components/dashboard/DoughnutProyecto"
import { UserContext } from '../../../context/provider/UserProvider';

const imagenReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

const docReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

export const ProduccionPorMetas = () => {
    const { empresas } = useEmpresas();

    const {
        entregable,
        guardarEntregable,
        editarValorEntregable,
        isOpenModalEntregable,
        openModalEntregable,
        closeModalEntregable,
        obtenerDetalleEntregable,
        eliminarEntregable,

    } = useEntregables()

    const {
        tiposTickets,
        prioridades,
        listarPrioridades,
        listarTiposTickets,
    } = useGeneral()
    
    const {
        usuarios,
        areas,
        listarUsuarios,
        listarUsuariosEmpresa,
        usuariosEmpresas,
        listarUsuarioTicketProyecto,
        usuariosProyecto,
        listarUsuarioTicketEntregable,
        usuariosEntregable
    } = useUsuarios()
    
    const {
        listarProyectos,
        proyectos,
        obtenerIdeaProyecto,
        idea,
        // editarValorIdeaProyecto,
        // registrarIdeaProyecto,
        obtenerDetalleInicioProyecto,
        inicio,
        // registrarInicioProyecto,
        // registrarInicioAutomatizado,
        editarValorInicioProyecto,
        analisis,
        listaAnalisis,
        obtenerAnalisisProyecto,
        // registrarAnalisisProyecto,
        editarValorAnalisisProyecto,
        isOpenModalProyecto,
        closeModalProyecto,
        listarEntregableActividadPorTicket,
        entregableActividades,
        loading,
        openModalProyecto,
        // finalizarProyecto,
        // editarValorFinalizarProyecto,
        finProyecto,
        listarFinalizarProyecto,
        // setLoading,
        eliminarAnalisisProyecto,
        // rechazarTicket,
    } = useProyectos()

    const {
        seguimientosTicket,
        listarSeguimientoTicket,
        nuevoSeguimientoTicket,
        editarValorNuevoSeguimiento,
        registrarSeguimientoPorTicket,
        editarValorSeguimiento,
        eliminarSeguimiento
    } = useSeguimientos()

    const {
            actividades,
            listarActividad,
            actividad,
            editarValorActividad,
            guardarEditarActividad,
            isOpenModalActividad,
            openModalActividad,
            closeModalActividad,
            obtenerActividadDetalle,
            actividadesPorTicket,
            listarActividadesPorTicket,
            eliminarActividad,
            regularizarActividad
    } = useActividades()

    useEffect(() => {
        (async ()=>{
            await listarPrioridades()
            await listarTiposTickets()
            await listarUsuarios(1)
            await listarUsuariosEmpresa(4)
        })()
    },[])

    const [ tipoProyecto, setTipoProyecto ] = useState(0);
    const { stateUser } = useContext(UserContext);
    const [ startDate, setStartDate ] = useState(agregarDias(-30));
    const [ endDate, setEndDate ] = useState(formatDate(new Date()));
    const [ opcionesSeleccionadas, setOpcionesSeleccionadas ] = useState([]);
    const [ esCrearSeguimiento, setEsCrearSeguimiento ] = useState(false);
    const [ valoresSeguimiento, setValoresSeguimiento ] = useState({indice: 0, codTicket: 0})
    const [ isOpenModalDetalleSeguimiento, openModalDetalleSeguimiento, closeModalDetalleSeguimiento ] = useModal(null);
    const [ isOpenModalImagen, openModalImagen, closeModalImagen ] = useModal(null)
    const [ isOpenModalEstados, openModalEstados, closeModalEstados] = useModal(null);
    const [ vistaProyecto, setVistaProyecto ] = useState(0);
    const [ imagenes, envioImagen ] = useReducer(imagenReducer, []);
    const [ documentos, envioDoc ] = useReducer(docReducer, []);
    const [ despliegue, setDespliegue ] = useState(false);
    const [ vistaHistorial, setVistaHistorial ] = useState(false);
    const [ limpiarSelect, setLimpiarSelect ] = useState(false);
    const [ analisisImagen, setAnalisisImagen ] = useState([]);
    const [ analisisDoc, setAnalisisDoc ] = useState([]);
    const [ verDetalleAnalisis, setVerDetalleAnalisis ] = useState(false);
    const [ totalConsolidado, setTotalConsolidado ] = useState(0);
    const [ graficoSeleccionado, setGraficoSeleccionado ] = useState('Donut');
    const idTablaProduccionMetas = "idTablaProduccionMetas";
    const classNameInput = "containerScroll caret-white lg:text-xs border-zinc-600 border text-white rounded w-full bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500";
    const classNameSelect = "rounded bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500 h-[30px] ";
    const arrayAreas = 
    [
        {
            "CodArea": "1",
            "NomArea": "SISTEMAS",
            "CodEstado": "1",
            "CodPersonaAreaConin": "2",
            "RestriccionAcceso": "0"
        },
        {
            "CodArea": "2",
            "NomArea": "ADMINISTRACIÓN",
            "CodEstado": "1",
        },
        {
            "CodArea": "3",
            "NomArea": "ELECTRONICA",
            "CodEstado": "1",
        },
        // {
        //     "CodArea": "4",
        //     "NomArea": "Ventas",
        //     "CodEstado": "1",
        // },
        // {
        //     "CodArea": "5",
        //     "NomArea": "SOPORTE TÉCNICO",
        //     "CodEstado": "1",
        // },
        // {
        //     "CodArea": "6",
        //     "NomArea": "RECURSOS HUMANOS",
        //     "CodEstado": "1",
        // },
        {
            "CodArea": "7",
            "NomArea": "ATENCIÓN AL CLIENTE",
            "CodEstado": "1",
        },
        // {
        //     "CodArea": "8",
        //     "NomArea": "Gerencia",
        //     "CodEstado": "1",
        // },
        {
            "CodArea": "9",
            "NomArea": "ANÁLISIS",
            "CodEstado": "1",
        }
    ]

    useEffect(() => {
        // setLoading(true)
        listarProyectos(tipoProyecto,startDate,endDate)
        // setLoading(false)
    },[tipoProyecto ,startDate, endDate])

    useEffect(() => {
        if(vistaProyecto !== 0){
            switch(vistaProyecto){
                case 1:
                    const asincronaImg = async () => {
                        const urlImagen = await parseURLArchivo(idea.parametrosImagen);
                        envioImagen({ tipo: 'Cargar', carga: urlImagen});
                    }
                    const asincronaDoc = async () => {
                        const urlDocumento = await parseURLArchivo(idea.parametrosArchivo);
                        envioDoc({ tipo: 'Cargar', carga: urlDocumento});
                    }
                    idea.parametrosImagen.length > 0 ? asincronaImg() : envioImagen({tipo: 'Reiniciar'});
                    idea.parametrosArchivo.length > 0 ? asincronaDoc() : envioDoc({tipo: 'Reiniciar'});
                    break;
                case 2:
                    const asincronaImgInicio = async () => {
                        const urlImagen = await parseURLArchivo(inicio.parametrosImagen);
                        envioImagen({ tipo: 'Cargar', carga: urlImagen});
                    }
                    const asincronaDocInicio = async () => {
                        const urlDocumento = await parseURLArchivo(inicio.parametrosArchivo);
                        envioDoc({ tipo: 'Cargar', carga: urlDocumento});
                    }
                    inicio.parametrosImagen.length > 0 ? asincronaImgInicio() : envioImagen({tipo: 'Reiniciar'});
                    inicio.parametrosArchivo.length > 0 ? asincronaDocInicio() : envioDoc({tipo: 'Reiniciar'});
                    break;
                case 3:
                    obtenerAnalisisProyecto(inicio.codTicket);
                    listarUsuarios(0)
                    editarValorAnalisisProyecto('codTicket',inicio.codTicket);
                    editarValorAnalisisProyecto('fechaInicioAnalisis',formatDate(new Date))
                    editarValorAnalisisProyecto('horaInicioAnalisis',obtenerHoraActual())
                    editarValorAnalisisProyecto('fechaFinAnalisis',formatDate(new Date))
                    editarValorAnalisisProyecto('horaFinAnalisis',obtenerHoraActual())
                    break;
                case 4:
                    listarEntregableActividadPorTicket(inicio.codTicket)
                    break;
                case 5:
                    listarActividadesPorTicket(inicio.codTicket)
                    break;
                case 6:
                    (async () => {
                        inicio.codEstadoTicket === 51 && await listarFinalizarProyecto(inicio.codTicket)
                        const asincronaImgFin = async () => {
                            const urlImagen = await parseURLArchivo(finProyecto.parametrosImagen);
                            envioImagen({ tipo: 'Cargar', carga: urlImagen});
                        }
                        const asincronaDocFin = async () => {
                            const urlDocumento = await parseURLArchivo(finProyecto.parametrosArchivo);
                            envioDoc({ tipo: 'Cargar', carga: urlDocumento});
                        }
                        finProyecto.parametrosImagen.length > 0 ? asincronaImgFin() : envioImagen({tipo: 'Reiniciar'});
                        finProyecto.parametrosArchivo.length > 0 ? asincronaDocFin() : envioDoc({tipo: 'Reiniciar'});

                    })()
                    break;
                case 7:
                    const asincronaImgRechazar = async () => {
                        const urlImagen = await parseURLArchivo(inicio.parametrosImagenRechazo);
                        envioImagen({ tipo: 'Cargar', carga: urlImagen});
                    }

                    inicio.parametrosImagenRechazo.length > 0 ? asincronaImgRechazar() : envioImagen({tipo: 'Reiniciar'});
                    break
                default:
                    break;
            }

        }
        (vistaProyecto !== 3  && verDetalleAnalisis && setVerDetalleAnalisis(false) )
    },[vistaProyecto])

    const usuariosConvertidos = usuarios.map(option => ({
        value: option.codUsuario,
        label: option.nomUsuario
    }));

    const usuariosEmpresaConvertidos = usuariosEmpresas?.map(option => ({
        value: option.codUsuario,
        label: option.nomUsuario
    }))

    const empresasConvertidas = empresas.map(option => ({
        value: option.codEmpresa,
        label: option.nomEmpresa
    }))

    const obtenerEstadoActividad = (codEstado) => {
        let nombreEstado = ''
        let color = ''
        switch(codEstado){
            case 9: //Pendiente
                nombreEstado = 'Pendiente'
                color = ' bg-yellow-500 '
                break;
            case 48: //En proceso
                nombreEstado = 'En proceso'
                color = ' bg-green-500 '
                break;
            case 51: //Finalizado
                nombreEstado = 'Finalizado'
                color = ' bg-red-500 '
                break;
            default:
                nombreEstado = 'Pausa'
                color = ' bg-cyan-500 '
            break
        }
        
        return <p className={`${color} w-[80px] text-center rounded px-2 text-xs py-1`}>{primeraLetraMayuscula(nombreEstado)}</p>
    }

    const asignarFechaActualInicio = async (fechaInicio, fechaFin) => {
        // FUNCION PARA AGREGAR UN MES - PARA PREDEFINIR LA FECHA FIN A UN MES
        const fecha = new Date();
        
        if(fechaInicio === '' && fechaFin === ''){
            editarValorInicioProyecto('fechaInicioProgramadoTicket',formatDate(new Date()));
            editarValorInicioProyecto('horaInicioProgramadoTicket',obtenerHoraActual());
            editarValorInicioProyecto('horaFinProgramadoTicket', obtenerHoraActual(2));
            editarValorInicioProyecto('fechaFinProgramadoTicket', formatDate(fecha));
        }
    }

    const registrarSeguimientoTicket = async (indice) => {
        const isValid = await registrarSeguimientoPorTicket(indice);
        if(isValid){
            editarValorNuevoSeguimiento('descripcion','')
            await listarSeguimientoTicket(valoresSeguimiento.codTicket)
            await listarProyectos(tipoProyecto, startDate, endDate)
        }
    }

    const parseURLArchivo = async (archivos) => {
        return archivos.map(option => {
            const nuevoObjeto = {};
            Object.keys(option).forEach(key => {
                if(key === 'codTicketArchivo'){
                    nuevoObjeto.codigo = option[key];
                }
                else
                    if(key.startsWith('nom')){
                        nuevoObjeto.nom = option[key];
                    }
                    else
                        if(key.startsWith('url')){
                            nuevoObjeto.url = option[key];
                        }
            });
            return nuevoObjeto;
        })
    }

    const actividadesAgrupadas = actividadesPorTicket?.reduce((acumulador, actividad) => {
        const { codTicketEntregable,nomEntregable } = actividad;
        const grupoExistente = acumulador.find(grupo => grupo.codTicketEntregable === codTicketEntregable)
        // const indiceTicket = acumulador.findIndex(item => item.codTicketEntregable === codTicketEntregable);

        if(!grupoExistente){
            acumulador.push({
                codTicketEntregable,
                nomEntregable,
                cantidadFilas: 1,
                actividades: [actividad]
            })
        }
        else{
            grupoExistente.actividades.push(actividad);
            grupoExistente.cantidadFilas++
        }
        return acumulador;
    }, []);

    const proyectosAgrupados = useMemo(() => {
        const agrupado = proyectos.reduce((acc, proyecto) => {
            const { nomEstado, nomArea } = proyecto;

            if (!acc[nomEstado]) {
                acc[nomEstado] = {
                    nomEstado: nomEstado,
                    total: 0,
                    porArea: {}
                };
                
                arrayAreas.forEach(area => {
                    acc[nomEstado].porArea[area.NomArea] = 0; 
                });
            }

            acc[nomEstado].total++;
            if (nomArea) {
                acc[nomEstado].porArea[nomArea] = (acc[nomEstado].porArea[nomArea] || 0) + 1;
            }

            return acc;
        }, {});
        return Object.values(agrupado)
    }, [proyectos, arrayAreas]);

    const dataGrafico = useMemo(() => {
        const labels = proyectosAgrupados.map(p => p.nomEstado);

        const datasets = arrayAreas.map((area, index) => {
            const colores = [ '#3b82f6', '#10b981', '#f59e0b', '#ef4444', 
                '#8b5cf6', '#ec4899', '#6b7280' ];

            return {
                label: area.NomArea,
                // Extraemos la cantidad de esa área específica para cada estado
                data: proyectosAgrupados.map(estado => estado.porArea[area.NomArea] || 0),
                backgroundColor: colores[index % colores.length],
            };
        });

        return { labels, datasets };
    }, [proyectosAgrupados, arrayAreas]);

    const proyectosAgrupadosTotal = proyectos.reduce((acumulador, proyecto) => {
        const { codEstado, nomEstado } = proyecto;
        const grupoExistente = acumulador.find(grupo => grupo.codEstado === codEstado);

        if (!grupoExistente) {
            acumulador.push({
                codEstado,
                nomEstado,
                cantidad: 1
            });
        } else {
            grupoExistente.cantidad++;
        }
        return acumulador;
    }, []);


    useEffect(() => {
        if(proyectosAgrupados.length > 0) {
            const total = proyectosAgrupados.reduce((sum, estado) => sum + estado.total, 0);
            setTotalConsolidado(total);
        }
    }, [proyectosAgrupados])

    const cerrarModalProyecto = () => {
        closeModalProyecto()
        setVistaProyecto(0);
        envioImagen({tipo: 'Reiniciar'});
        setVistaHistorial(false);
        setDespliegue(false);
    }
    return(
        <>
            {loading && <LineaCarga/>}
            <ContenedorParametros
                titulo='Gestión de producción por Metas'
                tablaId={idTablaProduccionMetas}
            >
                <MultiSelectorFecha
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    identificador='gestionProyecto'
                />
                <i
                    className="fa-solid fa-ellipsis-vertical cursor-pointer"
                    data-tip={'tipoConsulta'}
                    data-for={'tipoConsulta'}
                ></i>
                <Tooltip id={'tipoConsulta'}>Tipo de consulta</Tooltip>
                <select
                    className={`${classNameInput} h-[30px] lg:w-[80px] w-[140px]`}
                    onChange={(e) =>setTipoProyecto(Number(e.target.value))}
                >
                    <option value={0} key={'opc-todos'}>-- Todos --</option>
                    {
                        tiposTickets.map( tipo => (
                            <option
                                value={tipo.codTicketTipo}
                                key={tipo.codTicketTipo}
                            >{tipo.nomTicketTipo}</option>
                        ))
                    }
                </select>
                {
                    proyectos.length > 0 &&
                    <Filtro
                        nombreFiltros={['nomEstado','nomEmpresa','nomArea','nomPrioridad']}
                        seleccionDefault={['', '', stateUser.nomArea.toUpperCase(), '']}
                        data={proyectos}
                        setOpcionesSeleccionadas={setOpcionesSeleccionadas}
                    />
                }
                <BotonProcesar
                    onClick={()=> listarProyectos(tipoProyecto,startDate,endDate)}
                />
                <img
                    src="https://img.icons8.com/?size=96&id=UECmBSgBOvPT&format=png"
                    className="w-[40px] h-[40px] cursor-pointer"
                    onClick={() => ExportExcel(["tablaOcultaProyectosTotales"],'Gestión de producción por metas','Reporte de gestión de producción por metas')}
                ></img>
                <button
                    className="bg-green-600 px-2 rounded"
                    onClick={() => {
                        setGraficoSeleccionado('Donut');
                        setTotalConsolidado(0)
                        openModalEstados()
                    }}
                >Consolidado</button>
            </ContenedorParametros>

            <ContenedorTabla>
                <table
                    id={idTablaProduccionMetas}
                    className="tableResponsive"
                    // ref={tablaProyectoRef}
                >
                    <thead>
                        <tr key={'trCabecera0'}>
                            <th className="w-[3%]">N°</th>
                            <th className="w-[6%]">TICKET</th>
                            <th className="w-[10%]">FECHA REGISTRO</th>
                            <th className="W-[22%]">DESCRIPCIÓN DE META</th>
                            <th className="w-[10%]">AREA RESPONSABLE</th>
                            <th className="w-[11%]">RESPONSABLE DIRECTO</th>
                            <th className="w-[8%]">IMPORTANCIA</th>
                            <th className="w-[10%]">FECHA ACTIVIDAD</th>
                            <th className='w-[25%]'>SEGUIMIENTO</th>
                            <th className="w-[8%]">ESTADO</th>
                            <th className="w-[3%]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            proyectos.length > 0 ?
                            proyectos
                            .filter(elemento => {
                                const opcionesValidas = opcionesSeleccionadas.filter(opcion => opcion !== ''); // Filtrar opciones no vacías
                                return opcionesValidas.length === 0 || // Si no hay opciones válidas, incluir todos
                                    opcionesValidas.every(opcion => Object.values(elemento).includes(opcion)); 
                            })
                            .map((gest, i) => (
                                <tr key={`tr-meta_${i + 1}`}>
                                    <td className="bg-blue-600 text-center">{i + 1}</td>
                                    <td className="text-center">
                                        <label className="px-2 rounded-md bg-blue-600">{gest.registroPorPGI ? gest.codIncidencia : gest.codTicket}</label>
                                    </td>
                                    <td className="text-center">{gest.fechaRegistro}</td>
                                    <td
                                        className="w-[250px] min-w-[250px] max-w-[250px]"
                                        data-tip={'descripcion_'+ gest.codTicket}
                                        data-for={'descripcion_'+ gest.codTicket}
                                    >
                                        <div key={'descripcion_'+ gest.codTicket} className="whitespace-nowrap text-ellipsis overflow-hidden w-[98%]">{primeraLetraMayusculaOracion(gest.nomTicket)}</div>
                                        <Tooltip
                                            key={'tool_' + gest.codTicket}
                                            id={'descripcion_'+ gest.codTicket}
                                        >{primeraLetraMayusculaOracion(gest.nomTicket)}</Tooltip>
                                    </td>
                                    <td className="text-center">{primeraLetraMayusculaOracion(gest.nomArea)}</td>
                                    <td className="text-center">{gest.nomUsuarioResponsable}</td>
                                    <td className="text-center">{primeraLetraMayusculaOracion(gest.nomPrioridad)}</td>
                                    <td className="text-center">{gest.fechaPrimeraActividad || ""}</td>
                                    <td>
                                        <section key={'div_seg_'+ gest.codTicket} className='flex items-center gap-x-2 lg:justify-end'>
                                            {
                                                gest.codEstado === 51 ? '' : 
                                                    <>
                                                        <button
                                                            key={`agregarSeguimiento_0_${gest.codTicket}`}
                                                            className='bg-green-500 px-1 py-[1px] text-xs align-middle rounded hover:shadow-inner'
                                                            data-tip={'addFollow'}
                                                            data-for={'addFollow'}
                                                            onClick={async () => {
                                                                !esCrearSeguimiento && setEsCrearSeguimiento(true)
                                                                editarValorNuevoSeguimiento('descripcion','')
                                                                editarValorNuevoSeguimiento('codTicket',gest.codTicket)
                                                                setValoresSeguimiento({indice: 0, codTicket: gest.codTicket})
                                                                await listarSeguimientoTicket(gest.codTicket)
                                                                await openModalDetalleSeguimiento()
                                                            }}
                                                        >
                                                            <i className=' fa fa-plus'></i>
                                                        </button>
                                                        <Tooltip
                                                            id={'addFollow'}
                                                        >Agregar seguimiento</Tooltip>
                                                    </>
                    
                                            }
                                            {
                                                gest.seguimiento.length > 0 ?
                                                    <section
                                                        key={gest.codTicket + '_' + gest.nomTicket}
                                                        className='w-[90%] flex overflow-x-auto containerScroll lg:w-auto'
                                                    >
                                                        {
                                                            gest.seguimiento.map((det, i) => (
                                                                <>
                                                                    <button
                                                                        key={i + '_' + det.nomSeguimiento}
                                                                        data-tip={det.codSeguimiento + '_'}
                                                                        data-for={det.codSeguimiento + '_'}
                                                                        className={`px-1 py-[1px] text-xs bg-blue-500 border border-blue-900 rounded`}
                                                                        onClick={async () => {
                                                                            esCrearSeguimiento && setEsCrearSeguimiento(false)
                                                                            await listarSeguimientoTicket(gest.codTicket);
                                                                            setValoresSeguimiento({indice: i + 1, codTicket: gest.codTicket})
                                                                            await openModalDetalleSeguimiento()
                                                                        }}
                                                                    >
                                                                        {i + 1}
                                                                        {gest.seguimiento.length === (i + 1) && <i className="fa fa-circle text-red-600 text-[8px] absolute"></i>}
                                                                    </button>
                                                                    <Tooltip
                                                                        id={det.codSeguimiento + '_'}
                                                                    >{det.nomSeguimiento}</Tooltip>
                                                                </>
                                                            ))
                                                        }
                                                    </section>
                                                : <></>
                                            }
                                        </section>
                                    </td>
                                    <td className="text-center">{obtenerEstado(gest.codEstado,gest.nomEstado, gest.codTicket)}</td>
                                    <td className="text-center">
                                        <i
                                            className="fa fa-solid fa-bars text-blue-600 text-lg cursor-pointer"
                                            onClick={async () => {
                                                await obtenerIdeaProyecto(gest.codTicket)
                                                await obtenerDetalleInicioProyecto(gest.codTicket);
                                                await asignarFechaActualInicio(gest.fechaInicioProgramado || '', gest.fechaFinProgramado || '')
                                                setVistaProyecto(1);
                                                openModalProyecto();
                                            }}
                                        ></i>
                                    </td>
                                </tr>
                            ))
                            :
                            <tr key={'tr-sin-info'}><td colSpan={9} className="text-center">No hay información para mostrar...</td></tr>
                        }
                    </tbody>
                </table>

                <table
                    className='hidden'
                    id="tablaOcultaProyectosTotales"
                >
                    <thead>
                        <tr key={'tr-excel'}>
                            <th className="text-center">N°</th>
                            <th className="text-center">TICKET</th>
                            <th className="text-center">FECHA REGISTRO</th>
                            <th className="text-center">DESCRIPCIÓN DE META</th>
                            <th className="text-center">AREA RESPONSABLE</th>
                            <th className="text-center">RESPONSABLE DIRECTO</th>
                            <th className="text-center">IMPORTANCIA</th>
                            <th className="text-center">FECHA PRIMERA ACTIVIDAD</th>
                            <th className="text-center">SEGUIMIENTO</th>
                            <th className="text-center">ESTADO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            proyectos.length > 0 ?
                                proyectos
                                .filter(elemento => {
                                    const opcionesValidas = opcionesSeleccionadas.filter(opcion => opcion !== ''); // Filtrar opciones no vacías
                                    return opcionesValidas.length === 0 || // Si no hay opciones válidas, incluir todos
                                        opcionesValidas.every(opcion => Object.values(elemento).includes(opcion)); 
                                })
                                .map((p, i) => {
                                    return (
                                        <tr key={'tr-excel-'+ (i + 1)} >
                                            <td className="text-center">{++i}</td>
                                            <td className="text-center">
                                                <label className="px-2 rounded-md bg-blue-600 text-center">{p.registroPorPGI ? p.codIncidencia : p.codTicket}</label>
                                            </td>
                                            <td className="text-center">{p.fechaRegistro}</td>
                                            <td>{primeraLetraMayusculaOracion(p.nomTicket)}</td>
                                            <td className="text-center">{primeraLetraMayusculaOracion(p.nomArea)}</td>
                                            <td className="text-center">{p.nomUsuarioResponsable}</td>
                                            <td>{primeraLetraMayusculaOracion(p.nomPrioridad)}</td>
                                            <td className="text-center">{p.fechaPrimeraActividad || ""}</td>
                                            <td>
                                            {
                                                p.seguimiento.length > 0 ? 
                                                    p.seguimiento[p.seguimiento.length - 1].nomSeguimiento
                                                :
                                                    ""
                                            }
                                            </td>
                                            <td className="text-center">{obtenerEstado(p.codEstado, p.nomEstado, p.codTicket)}</td>
                                        </tr>
                                    )
                                })
                            :
                                <tr key={'tr-sin-info-excel'}><td colSpan="10" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>

            <ModalProyecto
                isOpen={isOpenModalProyecto}
                closeModal={cerrarModalProyecto}
                // action={() => guardarSegunVista()}
                title={`[${inicio.codTicket}] ${primeraLetraMayusculaOracion(inicio.nomTicket)}`}
                textButtons={{confirm: 'Guardar', denied: 'Cancelar'}}
                validButton={
                    {
                        confirm: false,//(inicio.codEstadoTicket !== 51 && inicio.codEstadoTicket !== 35 ) && (vistaProyecto !== 4 && vistaProyecto !== 5 && (inicio.codTicket !== 0 ? (vistaProyecto !== 1) : true )) ?  true : false,
                        denied: true
                    }
                }
            >
                <div className={`lg:flex-col lg: w-full   lg:flex h-full  overflow-visible`} key={'contenedor-proyecto'}>
                    <section
                        className='h-[5%] bg-[#1D1E1E] min-h-[28px]'
                        key={'_cabecera'}
                    >
                        {
                            inicio.codTicket !== 0 ?
                                <DetalleProyecto
                                    titulo={inicio.codTicket !== 0 ? `Ticket Nº  ${inicio.codTicket}` : 'Agregar detalle'}
                                    setDespliegue={setDespliegue} despliegue={despliegue}
                                >
                                    <div className='w-full grid grid-cols-2 items-start gap-4 lg:grid-cols-1 lg:gap-y-1'>
                                        <div className='grid grid-cols-[minmax(0,2fr)_minmax(0,8fr)] items-center gap-y-2 lg:grid-cols-[30%_70%] lg:gap-y-1 lg:text-xs'>
                                            <label className='lg:text-sm lg:w-full'>Área destino</label>
                                            <select
                                                className={`${classNameSelect} h-[30px] lg:text-sm lg:h-[30px] lg:w-[100%] text-center`}
                                                onChange={(e) => {
                                                    editarValorInicioProyecto('codAreaDestino',Number(e.target.value));
                                                    listarUsuarios(e.target.value);
                                                    setLimpiarSelect(!limpiarSelect)
                                                }}
                                                value={inicio.codAreaDestino}
                                            >
                                                {
                                                    areas?.length > 0 && inicio.identificador ? '' : 
                                                    <option key={0} value={0}>--Seleccione--</option>
                                                }
                                                {
                                                    areas?.length > 0 ?
                                                        areas.map(a =>(
                                                            <option key={a.codArea} value={a.codArea}>{a.nomArea}</option>
                                                        ))
                                                    :
                                                        <option>-- Seleccione --</option>
                                                }
                                            </select>
                                            <label className='lg:text-sm'>Responsable</label>
                                            <NuevoSelectAutocomplete
                                                options={usuariosConvertidos}
                                                valorInput={(valor) => editarValorInicioProyecto("codUsuarioResponsable",valor)}
                                                valorPorDefecto={inicio.codUsuarioResponsable}
                                                opcionSeleccione={inicio.opcionAutomatizar ? false : true}
                                            ></NuevoSelectAutocomplete>
                                            <label className='lg:text-sm'>Participantes</label>
                                            <MultiSelect
                                                search={true}
                                                data={usuarios}
                                                setEdit ={editarValorInicioProyecto}
                                                keyEdit={'codUsuarioParticipanteConcatenado'}
                                                width={'w-[100%]'}
                                                defaultValue={inicio.codUsuarioParticipanteConcatenado}
                                                isBlocket={false}
                                            />
                                            <label className='lg:text-sm'>Fecha Inicio</label>
                                            <div className='flex lg:gap-2'>
                                                <div className='w-[120px] lg:w-[80px] lg:pr-1'>
                                                    <DatePickerABX
                                                        date={inicio.fechaInicioProgramadoTicket}
                                                        setDate={editarValorInicioProyecto}
                                                        classNameInput={'lg:w-[70px] lg:text-xs lg:p-[2px] bg-zinc-800 border border-zinc-600'}
                                                        keyDate='fechaInicioProgramadoTicket'
                                                        ocultarIcono={true}
                                                    />
                                                </div>
                                                <input
                                                    type='time'
                                                    className={`bg-zinc-800 ${classNameInput} h-[30px] w-[100px] lg:w-[70px] p-1 text-sm lg:text-xs lg:p-[1px]`}
                                                    value={inicio.horaInicioProgramadoTicket}
                                                    onChange={(e) => editarValorInicioProyecto('horaInicioProgramadoTicket',e.target.value)}
                                                    
                                                />
                                            </div>
                                            <label className='lg:text-sm'>Fecha Fin</label>
                                            <div className='flex lg:gap-2'>
                                                <div className='w-[120px] lg:w-[80px] lg:pr-1'>
                                                    <DatePickerABX
                                                        date={inicio.fechaFinProgramadoTicket}
                                                        setDate={editarValorInicioProyecto}
                                                        keyDate={'fechaFinProgramadoTicket'}
                                                        classNameInput={'lg:w-[70px] lg:text-xs lg:p-[2px] bg-zinc-800 border border-zinc-600'}
                                                        ocultarIcono={true}
                                                    />
                                                </div>
                                                <input
                                                    type='time'
                                                    className={`bg-zinc-800 ${classNameInput} h-[30px] w-[100px] lg:w-[70px] p-1 text-sm lg:text-xs lg:p-[1px]`}
                                                    value={inicio.horaFinProgramadoTicket}
                                                    onChange={(e) => editarValorInicioProyecto('horaFinProgramadoTicket',e.target.value)}
                                                />
                                            </div>

                                        </div>
                                        <div className='grid grid-cols-[minmax(0,2fr)_minmax(0,8fr)] items-center gap-y-2 lg:grid-cols-[30%_70%] lg:gap-y-1 lg:text-xs'>
                                            <label className='lg:text-sm'>Empresa</label>
                                            <NuevoSelectAutocomplete
                                                options={empresasConvertidas}
                                                valorInput={(valor) => {editarValorInicioProyecto("codEmpresa",valor);listarUsuariosEmpresa(valor)}}
                                                valorPorDefecto={inicio.codEmpresa}
                                                opcionSeleccione={inicio.identificador ? false : true}
                                            ></NuevoSelectAutocomplete>
                                            <label className='lg:text-sm'>Contacto</label>
                                            <NuevoSelectAutocomplete
                                                options={usuariosEmpresaConvertidos}
                                                valorInput={(valor) => editarValorInicioProyecto("codUsuarioSolicitante",valor)}
                                                valorPorDefecto={inicio.codUsuarioSolicitante}
                                                opcionSeleccione={inicio.identificador ? false : true}
                                            ></NuevoSelectAutocomplete>
                                            <span className='lg:text-sm'>Tipo</span>
                                            <select
                                                className={`${classNameSelect} h-[30px] lg:text-sm lg:h-[30px] lg:w-[100%] text-center `}
                                                onChange={(e) => {
                                                    (!inicio.opcionAutomatizar) && editarValorInicioProyecto('automatizarIncidencia',false)
                                                    editarValorInicioProyecto("codTicketTipo", Number(e.target.value))
                                                }}
                                                value={inicio.codTicketTipo}
                                            >
                                                {
                                                    tiposTickets?.length > 0 && inicio.identificador ? '' : 
                                                    <option key={0} value={0}>--Seleccione--</option>
                                                }
                                                {
                                                    tiposTickets?.length > 0 ?
                                                        tiposTickets.map(tt =>{
                                                            return <option key={tt.codTicketTipo} value={tt.codTicketTipo}>{tt.nomTicketTipo}</option>
                                                        })
                                                    :
                                                        <option key={-1} value={-1}>--Sin información para mostrar--</option>
                                                }
                                            </select>
                                            <label className='lg:text-sm lg:w-full'>Prioridad</label>
                                            <select
                                                className={`${classNameSelect} h-[30px] lg:text-sm lg:h-[30px] lg:w-[100%] text-center`}
                                                onChange={(e)=>editarValorInicioProyecto('codPrioridad',Number(e.target.value))}
                                                value={inicio.codPrioridad}
                                            >
                                                {
                                                    prioridades.length > 0 && inicio.identificador ? '' : 
                                                    <option key={0} value={0}>--Seleccione--</option>
                                                }
                                                {
                                                    prioridades.length > 0 ?
                                                        prioridades.map(p => (
                                                            <option key={p.codPrioridad} value={p.codPrioridad}>{p.nomPrioridad}</option>
                                                        ))
                                                    :
                                                        <option value={-1}>-- Seleccione --</option>
                                                }
                                            </select>
                                            <label className='lg:text-sm lg:w-full'>Creación</label>
                                            <input
                                                className={`bg-zinc-800 ${classNameInput} text-sm p-2 h-[30px] w-[40%]  lg:text-sm lg:h-[30px] lg:w-[100%]`}
                                                readOnly
                                                disabled
                                                value={inicio.fechaRegistro}
                                            />
                                            {/* {
                                                Number(inicio.codTicketTipo) === 3 && inicio.opcionAutomatizar == 0 ?
                                                    <>
                                                        <label className='lg:text-sm lg:w-full'>Automatizar registros</label>
                                                        <SwitchToggle
                                                            keyEdit={"automatizarIncidencia"}
                                                            setEdit={editarValorInicioProyecto}
                                                            valor={inicio.automatizarIncidencia}
                                                        />
                                                    </>
                                                : 
                                                    <></>
                                            } */}
                                        </div>
                                    </div>
                                </DetalleProyecto>
                            :
                                <></>
                        }
                    </section>
                    <section className='flex lg:flex-col h-[95%] min-w-[150px] lg:w-full '>
                        <section
                            className='w-[15%] min-w-[150px] lg:w-full flex flex-col lg:flex-row overflow-y-auto
                            gap-2 bg-[#2B2C2E] py-5 px-5 lg:py-1 lg:px-1 h-full lg:h-[10%] lg:min-h-0 lg:items-center
                            lg:overflow-y-hidden  lg:overflow-x-auto containerScroll'
                        >
                            <FasesProyecto
                                setVista={setVistaProyecto}
                                vista={vistaProyecto}
                                data={{
                                    codigoIdentificador : inicio.identificador,
                                    codigo: inicio.codTicket,
                                    nombre: inicio.nomTicket,
                                    estado: inicio.codEstadoTicket
                                }}
                                envioImagen={envioImagen}
                                envioDoc={envioDoc}
                            />
                        </section>
                        <section
                            className='flex lg:flex-col w-[85%] min-w[] p-5 lg:p-3 h-full lg:h-[90%] lg:w-full min-h-[300px]'
                        >
                            {
                                vistaProyecto === 1 &&
                                <section className='w-full h-full p-3 lg:p-0 grid
                                grid-cols-[minmax(0,7fr)_minmax(0,3fr)] gap-x-4 lg:grid-cols-1 lg:gap-x-0'
                                >
                                    <section className='flex flex-col '>
                                        <label
                                            htmlFor='nomTituloIdea'
                                            className='text-[#368ad8d0] font-semibold lg:hidden'
                                        >Título de la idea (Necesidad o problema)</label>
                                        <label
                                            htmlFor='nomTituloIdea'
                                            className='text-[#368ad8d0] font-semibold hidden lg:flex'
                                        >Título de la idea</label>
                                        <input
                                            className={`w-full lg:text-xs lg:ml-0 px-2 py-1  ${classNameInput}`}
                                            value={idea.nomTicketIdea}
                                            // onChange={(e)=>editarValorIdeaProyecto('nomTicketIdea',e.target.value)}
                                            placeholder='Escribir aquí la necesidad o problema'
                                            id={'nomTituloIdea'}
                                            disabled
                                            // disabled={inicio.codTicket === 0 ? false : true}
                                        />
                                        <label
                                            htmlFor='descripcionIdea'
                                            className='text-[#368ad8d0] font-semibold'
                                        >Descripción</label>
                                        <textarea
                                            id={'descripcionIdea'}
                                            className={`flex-grow  lg:text-xs px-2 ${classNameInput} resize-none`}
                                            value={idea.contenidoTicketIdea}
                                            // onChange={(e)=> editarValorIdeaProyecto("contenidoTicketIdea",e.target.value )}
                                            placeholder='Escribir aquí la descripción de la idea'
                                            disabled
                                        />
                                        <label
                                            className='text-[#368ad8d0] font-semibold lg:w-full'
                                            htmlFor={'solicitanteIdea'}
                                        >Solicitante o autor</label>
                                        <input
                                            id={'solicitanteIdea'}
                                            className={`${classNameInput} w-[100%] lg:text-xs lg:ml-0 lg:w-full  px-2 py-1 `}
                                            value={idea.solicitanteIdea}
                                            // onChange={(e) => editarValorIdeaProyecto('solicitanteIdea',e.target.value)}
                                            placeholder='Escribir aquí el nombre de la persona que solicita la idea'
                                            disabled
                                        />

                                    </section>
                                    <section className='flex flex-col h-full min-h-0'>
                                        <label className=' text-[#368ad8d0] font-semibold'>Adjunto</label>
                                        <section className='min-h-0 h-full grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1'>
                                            <ContenedorImagen
                                                envioImagen={envioImagen}
                                                archivo={imagenes}
                                                esBloqueo={inicio.codTicket == 0 ?  false : true}//inicio.codTicket !== 0 ?  true : false}
                                                className={''}
                                            />
                                            <ContenedorDocumento
                                                envioDocumento={envioDoc}
                                                archivo={documentos}
                                                esBloqueo={inicio.codTicket == 0 ?  false : true}//inicio.codTicket !== 0 ?  true : false}
                                                className={''}
                                            />
                                        </section>
                                    </section>
                                </section>
                            }

                            {
                                vistaProyecto === 2 &&
                                    <section
                                        className='w-full h-full p-3 grid lg:p-0
                                        grid-cols-[minmax(0,7fr)_minmax(0,3fr)] gap-x-4 lg:grid-cols-1 lg:gap-x-0'
                                    >
                                        <section className='flex flex-col'>
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='nomTicket'
                                            >Título</label>
                                            <input
                                                id='nomTicket'
                                                className={` w-full lg:text-xs lg:ml-0  px-2 py-1  ${classNameInput}`}
                                                value={inicio.nomTicket}
                                                // onChange={(e)=>editarValorInicioProyecto('nomTicket',e.target.value)}
                                                disabled={inicio.identificador}
                                                placeholder='Escribir aquí el título'
                                            />
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='nomObjetivo'
                                            >Objetivo</label>
                                            <textarea
                                                id='nomObjetivo'
                                                className={`w-full lg:text-xs px-2 ${classNameInput} flex-grow resize-none`}
                                                value={inicio.objetivo}
                                                // onChange={(e)=> editarValorInicioProyecto("objetivo",e.target.value )}
                                                placeholder='Describa el objetivo del desarrollo...'
                                                disabled={inicio.automatizarIncidencia ? true : false}
                                                readOnly={inicio.automatizarIncidencia ? true : false}
                                            />
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='nomAlcance'
                                            >Alcance</label>
                                            <textarea
                                                id='nomAlcance'
                                                className={` w-full lg:text-xs flex-grow px-2 ${classNameInput} resize-none`}
                                                value={inicio.alcance}
                                                // onChange={(e)=> editarValorInicioProyecto("alcance",e.target.value )}
                                                placeholder='Describa el alcance del proyecto, incidencia o requerimiento'
                                                disabled={inicio.automatizarIncidencia ? true : false}
                                                readOnly={inicio.automatizarIncidencia ? true : false}
                                            />
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='nomInteresados'
                                            >Interesados o patrocinador</label>
                                            <textarea
                                                id='nomInteresados'
                                                className={` w-full lg:text-xs flex-grow px-2 ${classNameInput} resize-none`}
                                                value={inicio.interesados}
                                                // onChange={(e)=> editarValorInicioProyecto("interesados",e.target.value )}
                                                placeholder='Escribir aquí quienes estan interesados en el proyecto'
                                                disabled={inicio.automatizarIncidencia ? true : false}
                                                readOnly={inicio.automatizarIncidencia ? true : false}
                                            />
                                        </section>
                                        <section className='flex flex-col h-full min-h-0'>
                                            <label className=' text-[#368ad8d0] font-semibold'>Adjunto</label>
                                            <section className='h-full grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1 min-h-0'>
                                                <div className='overflow-auto'>
                                                    <ContenedorImagen
                                                        envioImagen={envioImagen}
                                                        archivo={imagenes}
                                                        esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                        className={''}
                                                    />
                                                </div>
                                                <ContenedorDocumento
                                                    envioDocumento={envioDoc}
                                                    archivo={documentos}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                            </section>
                                        </section>
                                    </section>
                            }
                            {
                                vistaProyecto === 3 &&
                                (
                                    !vistaHistorial ? 
                                    <section
                                        className={`w-full h-full p-3 lg:p-0 grid
                                        grid-cols-[minmax(0,7fr)_minmax(0,3fr)] gap-x-4 lg:grid-cols-1 lg:gap-x-0 `}
                                    >
                                        <section className='flex flex-col'>
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='tituloAnalisis'
                                            >Título análisis</label>
                                            <input
                                                id='tituloAnalisis'
                                                className={`px-2 py-1 w-full ${classNameInput} `}
                                                // onChange={(e) => editarValorAnalisisProyecto('titulo', e.target.value)}
                                                value={analisis.titulo}
                                                placeholder='Escriba aquí el titulo de su analisis'
                                            />
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='descripcionAnalisis'
                                            >Descripción</label>
                                            <textarea
                                                id='descripcionAnalisis'
                                                className={`w-full ${classNameInput} flex-grow px-2 py-1 resize-none`}
                                                // onChange={(e) => editarValorAnalisisProyecto('descripcionAnalisis', e.target.value)}
                                                value={analisis.descripcionAnalisis}
                                                placeholder='Descripción breve de su análisis'
                                            />
                                            <div className='w-full grid grid-cols-[minmax(0,3fr)_minmax(0,7fr)] gap-x-2'>
                                                <span className='text-[#368ad8d0] font-semibold '>Fecha hora inicio</span>
                                                <span className='text-[#368ad8d0]'>Participantes</span>
                                                <div className='flex gap-1 w-full'>
                                                    <DatePickerABX
                                                        date={analisis.fechaInicioAnalisis}
                                                        setDate={editarValorAnalisisProyecto}
                                                        classNameInput={`${classNameInput} flex-grow`}
                                                        keyDate='fechaInicioAnalisis'
                                                        ocultarIcono={true}
                                                    />
                                                    <input
                                                        type='time'
                                                        className={`${classNameInput} flex-grow lg:w-[90px] w-[100px] px-2 py-1 text-sm`}
                                                        defaultValue={analisis.horaInicioAnalisis}
                                                        // onChange={(e) => editarValorAnalisisProyecto('horaInicioAnalisis',e.target.value)}
                                                    />
                                                </div>
                                                <div className='flex-grow'>
                                                    <MultiSelect
                                                        search={true}
                                                        data={usuarios}
                                                        setEdit ={editarValorAnalisisProyecto}
                                                        keyEdit={'codUsuarioParticipanteConcatenado'}
                                                        width={'w-[100%]'}
                                                        defaultValue={analisis.codUsuarioParticipanteConcatenado}
                                                        isBlocket={true}
                                                        classNameSelect={'bg-zinc-900 border border-zinc-600'}
                                                    />
                                                </div>
                                            </div>
                                            <span className='text-[#368ad8d0] font-semibold'>Fecha hora fin</span>
                                            <div className='flex gap-1 w-[30%]'>
                                                <DatePickerABX
                                                    date={analisis.fechaFinAnalisis}
                                                    setDate={editarValorAnalisisProyecto}
                                                    classNameInput={' lg:w-[100px] w-[150px] lg:text-xs lg:p-[2px] bg-zinc-900 border border-zinc-600 '}
                                                    keyDate='fechaFinAnalisis'
                                                    ocultarIcono={true}
                                                />
                                                <input
                                                    type='time'
                                                    className={`${classNameInput} lg:w-[90px] flex-grow px-2 py-1 text-sm`}
                                                    value={analisis.horaFinAnalisis}
                                                    // onChange={(e) => editarValorAnalisisProyecto('horaFinAnalisis',e.target.value)}
                                                />
                                            </div>
                                            <div className='pt-2'>
                                                <button
                                                    className={`bg-slate-500 w-[100px] p-1 rounded-md`}
                                                    onClick={() => setVistaHistorial(true)}
                                                >Ver historial</button>
                                            </div>
                                            
                                        </section>
                                        <section className='flex flex-col h-full min-h-0'>
                                            <label className=' text-[#368ad8d0] font-semibold'>Prototipo</label>
                                            <section className='h-full min-h-0 grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1'>
                                                <ContenedorImagen
                                                    envioImagen={envioImagen}
                                                    archivo={imagenes}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                                <ContenedorDocumento
                                                    envioDocumento={envioDoc}
                                                    archivo={documentos}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                            </section>
                                        </section>
                                    </section>
                                    :
                                    <section className='w-full overflow-x-auto containerScroll'>
                                        <table className='tableResponsive'>
                                            <thead>
                                                <tr>
                                                    <th className='w-[5%] text-center'>N</th>
                                                    <th className='w-[35%] min-w-[35%]'>DESCRIPCION</th>
                                                    <th className='w-[10%]'>PARTICIPANTES</th>
                                                    <th className='w-[10%]'>F. INICIO</th>
                                                    <th className='w-[10%]'>F. FIN</th>
                                                    <th className='w-[10%]'>U. CREACIÓN</th>
                                                    <th className='w-[10%] whitespace-nowrap'>F. CREACIÓN</th>
                                                    <th className='w-[5%]'></th>
                                                    <th className='w-[5%]'></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    listaAnalisis?.length > 0 ? 
                                                        listaAnalisis.map((data, i) => (
                                                            <tr onClick={(e)=> pintarFila(e.target)}>
                                                                <td className='w-[5%] text-center'>{i + 1}</td>
                                                                <td className='w-[350px]'
                                                                    data-tip={'descripcion_' + (data.codTicketAnalisis||0)}
                                                                    data-for={'descripcion_' + (data.codTicketAnalisis||0)}
                                                                    >
                                                                    <div className='whitespace-nowrap overflow-hidden text-ellipsis w-[345px]'>
                                                                        {data.descripcionAnalisis}
                                                                    </div>
                                                                    <Tooltip id={'descripcion_' + (data.codTicketAnalisis||0)}>{data.descripcionAnalisis}</Tooltip>
                                                                </td>
                                                                <td className='w-[150px]'
                                                                    title={data.nomUsuarioParticipanteConcatenado}
                                                                    data-tip={'participantes_' + (data.codTicketAnalisis||0)}
                                                                    data-for={'participantes_' + (data.codTicketAnalisis||0)}
                                                                >
                                                                    <div className='w-[145px] whitespace-nowrap overflow-hidden text-ellipsis'>
                                                                        {data.nomUsuarioParticipanteConcatenado}
                                                                    </div>
                                                                    <Tooltip id={'participantes_' + (data.codTicketAnalisis||0)}>{data.nomUsuarioParticipanteConcatenado}</Tooltip>
                                                                </td>
                                                                <td className='whitespace-nowrap w-[10%]'>{data.fechaInicioReal}</td>
                                                                <td className='whitespace-nowrap w-[10%]'>{data.fechaFinReal}</td>
                                                                <td className='whitespace-nowrap w-[10%]'>{data.nomUsuarioRegistro}</td>
                                                                <td className='w-[5%] whitespace-nowrap'>{data.fechaRegistro}</td>
                                                                <td className=' w-[5%] text-center'>
                                                                    {
                                                                        data.parametrosArchivo.length > 0 || data.parametrosImagen.length > 0 ? 
                                                                            <i
                                                                                className='fa fa-file text-blue-500'
                                                                                onClick={async () => {
                                                                                    let urlDocumento = data.parametrosArchivo.length > 0 ? await parseURLArchivo(data.parametrosArchivo) : [];
                                                                                    let urImagen = data.parametrosImagen.length > 0 ? await parseURLArchivo(data.parametrosImagen) : [];
                                                                                    setAnalisisImagen(urImagen)
                                                                                    setAnalisisDoc(urlDocumento)
                                                                                    openModalImagen()
                                                                                }}
                                                                            ></i>
                                                                        :
                                                                            <></>
                                                                    }
                                                                </td>

                                                                <td className=' w-[5%] text-center'>   
                                                                    <i
                                                                        className=' fa fa-ligth fa-trash text-red-500'
                                                                        onClick={async () => { 
                                                                            const isValid = await eliminarAnalisisProyecto(data.codTicketAnalisis)
                                                                            isValid && obtenerAnalisisProyecto(inicio.codTicket)
                                                                        }}
                                                                    ></i>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    :
                                                    <tr><td colSpan={10} className='text-center'>No hay información para mostrar...</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                        <section className='px-2 py-4'>
                                            <button
                                                className='bg-slate-500 w-[200px] p-1 rounded-md'
                                                onClick={() => setVistaHistorial(false)}
                                            ><i className='fa fa-reply pr-2'></i>Regresar al registro</button>
                                        </section>
                                    </section>

                                )
                            }
                            {
                                vistaProyecto === 4 &&
                                    <section className='w-full overflow-y-auto containerScroll lg:h-full'>
                                        <div className="text-xs h-full flex ">
                                            <div className="">
                                                <div className=' cuadroProyecto p-0 w-[50%] left-[25%] right-[25%]'>
                                                    <div className='h-full flex items-center'>
                                                        <div className='flex gap-2 justify-center items-center px-2 w-[100%]'>
                                                            <span
                                                                className='text-xl whitespace-nowrap text-ellipsis overflow-hidden lg:text-xs w-[95%] h-full'
                                                                data-tip={'nombreEntregable'+entregableActividades.codTicket}
                                                                data-for={'nombreEntregable'+entregableActividades.codTicket}
                                                            >
                                                                {entregableActividades.nomTicket || ''}
                                                            </span>
                                                            <Tooltip id={'nombreEntregable'+entregableActividades.codTicket}>{entregableActividades.nomTicket || ''}</Tooltip>
                                                            {/* <i
                                                                className='fa fa-plus-circle w-[5%] h-full text-base cursor-pointer hover:text-blue-500'
                                                                data-tip={'crearEntregable'+entregableActividades.codTicket}
                                                                data-for={'crearEntregable'+entregableActividades.codTicket}
                                                                onClick={async () => {
                                                                    await listarUsuarioTicketProyecto(entregableActividades.codTicket);
                                                                    await obtenerDetalleEntregable();
                                                                    asignarFechaActualEntregable()
                                                                    openModalEntregable()
                                                                }}
                                                            ></i>
                                                            <Tooltip id={'crearEntregable'+entregableActividades.codTicket}>Crear entregable</Tooltip> */}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='flex border-b-4 h-[20px] w-full min-w-[600px]'>
                                                    <div className='flex  border-r-2 w-[50%]'></div>
                                                    <div className='flex  border-l-2 w-[50%]'></div>
                                                </div>

                                                <div className='z-5 h-[20px]'></div>
                                                <ul className="flex">
                                                    {
                                                        entregableActividades.entregable.length > 0 &&
                                                            entregableActividades.entregable.map((entregable,i) => {
                                                                return(
                                                                    entregable.codTicketEntregable !== 0 &&
                                                                    <>

                                                                        <li
                                                                            key={entregable.codTicketEntregable + (i + 1)}
                                                                            className='cuadroActividades h-full flex flex-col gap-4 w-[200px] p-2 '
                                                                        >
                                                                            <div className='cuadroEntregable rounded-lg'>
                                                                                <p
                                                                                    className='hover:text-blue-500 hover:decoration-blue-500
                                                                                    cursor-pointer py-1 text-sm decoration-white
                                                                                    whitespace-nowrap text-ellipsis overflow-hidden text-center'
                                                                                    data-tip={'entregable'+entregable.codTicketEntregable}
                                                                                    data-for={'entregable'+entregable.codTicketEntregable}
                                                                                    onClick={async () => {
                                                                                        await listarUsuarioTicketProyecto(entregableActividades.codTicket)
                                                                                        await obtenerDetalleEntregable(entregable.codTicketEntregable);
                                                                                        openModalEntregable()
                                                                                    }}
                                                                                >
                                                                                    {entregable.nomEntregable}
                                                                                </p>
                                                                                <Tooltip id={'entregable'+entregable.codTicketEntregable}>{entregable.nomEntregable}</Tooltip>
                                                                                {/* <i
                                                                                    className='fa fa-plus-circle cursor-pointer px-2 hover:text-blue-500'
                                                                                    data-for={'crearActividad'}
                                                                                    data-tip={'crearActividad'}
                                                                                    onClick={async () => {
                                                                                        await listarUsuarioTicketEntregable(entregable.codTicketEntregable)
                                                                                        await obtenerActividadDetalle()
                                                                                        await listarActividad(entregable.codTicketEntregable)
                                                                                        editarValorActividad('codTicketEntregable',entregable.codTicketEntregable);
                                                                                        asignarFechaActualActividad()
                                                                                        openModalActividad();
                                                                                    }}
                                                                                ></i>
                                                                                <Tooltip id={'crearActividad'}>Crear Actividad</Tooltip> */}
                                                                            </div>
                                                                            {/* {
                                                                                entregable.actividades[0].codEstadoTicketActividad === 0 &&
                                                                                <>
                                                                                    <i
                                                                                        className='fa fa-times-circle absolute top-1 right-1 cursor-pointer z-10'
                                                                                        data-for={'eliminarEntregable'}
                                                                                        data-tip={'eliminarEntregable'}
                                                                                        onClick={() => {
                                                                                            editarValorActividad('codTicketActividad', 0);
                                                                                            editarValorActividad('codTicketEntregable', entregable.codTicketEntregable);
                                                                                            openModalEliminarEntregable();
                                                                                        }}
                                                                                    ></i>
                                                                                    <Tooltip id={'eliminarEntregable'}>Eliminar entregable</Tooltip>
                                                                                </>
                                                                            } */}
                                                                            <div>
                                                                                <ul className='border-l-4 w-[100%] flex flex-col gap-3 '>
                                                                                    {
                                                                                        entregable?.actividades?.map((actividad, subIndex) => (
                                                                                            actividad.codTicketActividad !== 0 &&
                                                                                            <li key={subIndex} className=''>
                                                                                                <section
                                                                                                    className='rounded  flex items-center'
                                                                                                    // onAuxClick={()=> copiarTexto('Ticket Nº ' + inicio.codTicket +'\n'+ 'Actividad: ' + actividad.codTicketActividad)}
                                                                                                >
                                                                                                    <span
                                                                                                        className='hover:text-blue-500 hover:decoration-blue-500 cursor-pointer p-1
                                                                                                        text-sm decoration-white w-[95%] whitespace-nowrap text-ellipsis overflow-hidden'
                                                                                                        data-tip={'nombreActividad'+actividad.codTicketActividad}
                                                                                                        data-for={'nombreActividad'+actividad.codTicketActividad}
                                                                                                        // onClick={async () => {
                                                                                                        //     await listarUsuarioTicketEntregable(entregable.codTicketEntregable)
                                                                                                        //     await obtenerActividadDetalle(actividad.codTicketActividad);
                                                                                                        //     await listarActividad(entregable.codTicketEntregable);
                                                                                                        //     openModalActividad()
                                                                                                        // }}
                                                                                                    >{actividad.nomActividad}</span>
                                                                                                    <Tooltip id={'nombreActividad'+actividad.codTicketActividad}>{actividad.nomActividad}</Tooltip>
                                                                                                </section>
                                                                                                {/* {
                                                                                                    actividad.codEstadoTicketActividad === 9 &&
                                                                                                        <>
                                                                                                            <i
                                                                                                                className='fa fa-times-circle text-red-500 cursor-pointer absolute top-2  -right-3 '
                                                                                                                data-for={'eliminarActividad'}
                                                                                                                data-tip={'eliminarActividad'}
                                                                                                                onClick={() => {
                                                                                                                    editarValorActividad('codTicketEntregable', 0);
                                                                                                                    editarValorActividad('codTicketActividad',actividad.codTicketActividad);
                                                                                                                    openModalEliminarEntregable();
                                                                                                                }}
                                                                                                            ></i>
                                                                                                            <Tooltip id={'eliminarActividad'}>Eliminar actividad</Tooltip>
                                                                                                            <i
                                                                                                                className="fa fa-check-circle text-green-500 cursor-pointer absolute top-6 -right-3"
                                                                                                                data-for={'regularizarActividad'}
                                                                                                                data-tip={'regularizarActividad'}
                                                                                                                onClick={() => registrarActividadRegularizada(actividad.codTicketActividad)}
                                                                                                            ></i>
                                                                                                            <Tooltip id={'regularizarActividad'}>Regularizar actividad</Tooltip>
                                                                                                        </>
                                                                                                    } */}

                                                                                            </li>

                                                                                        ))
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        </li>
                                                                    </>
                                                                )
                                                            })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </section>
                            }
                            {
                                vistaProyecto === 5 &&
                                    <div className='w-full'>
                                        <div className=" containerScroll text-xs relative top-0 h-[480px] max-h-[480px]  bottom-0 left-0 right-0 contenedor-tabla" >
                                            <table className=" tableResponsive  ">
                                                <thead className=''>
                                                    <tr>
                                                        <th className="w-[10px]">N°</th>
                                                        <th className="w-[20px]">COD</th>
                                                        <th className="w-[20px]">ENTREGABLE</th>
                                                        <th className="w-[250px]">ACTIVIDAD</th>
                                                        <th className="w-[100px]">RESPONSABLE</th>
                                                        <th className="w-[100px] whitespace-nowrap">F.INICIO PROG.</th>
                                                        <th className="w-[100px] whitespace-nowrap">F.FIN PROG.</th>
                                                        <th className="w-[100px] whitespace-nowrap">F.INICIO REAL</th>
                                                        <th className="w-[100px] whitespace-nowrap">F.FIN REAL</th>
                                                        <th className="w-[100px]">ESTADO</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {

                                                    actividadesAgrupadas?.length > 0 ?
                                                        (
                                                            actividadesAgrupadas.map((entregable, i) => {
                                                                return entregable.actividades.map((actividad,j) => {
                                                                    return(
                                                                        <>
                                                                            <tr key={entregable.codTicketEntregable}>
                                                                                {
                                                                                    (j === 0) && (
                                                                                        <>
                                                                                            <td rowSpan={entregable.cantidadFilas} className='w-[40px] text-center'>
                                                                                                <span className='w-[40px]'>{i+1}</span>
                                                                                            </td>
                                                                                            <td rowSpan={entregable.cantidadFilas} className='text-center min-w-[70px] w-[70px]'>
                                                                                                <div className='w-[70px] text-center'>
                                                                                                    <span className='bg-green-500 px-2 py-1 rounded'>{entregable.codTicketEntregable}</span>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td rowSpan={ entregable.cantidadFilas} >
                                                                                                <div className='w-[250px] flex gap-2 items-center'>
                                                                                                    <span className='whitespace-nowrap w-[90%] text-ellipsis overflow-hidden '>{entregable.nomEntregable}</span>
                                                                                                </div>
                                                                                            </td>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                                <td>
                                                                                    <div className='whitespace-nowrap text-ellipsis overflow-hidden w-[200px] px-1 py-1'>
                                                                                        <span
                                                                                            className='bg-blue-600 px-2 rounded mr-1'
                                                                                            // onClick={() => copiarTexto('Ticket Nº ' + inicio.codTicket +'\n'+ 'Actividad: ' + actividad.codTicketActividad)}
                                                                                        >{actividad.codTicketActividad}</span>
                                                                                        <span data-tip={'nomActividad'+j+'-'+actividad.codTicketActividad} data-for={'nomActividad'+j+'-'+actividad.codTicketActividad}>{actividad.nomActividad}</span>
                                                                                        <Tooltip id={'nomActividad'+j+'-'+actividad.codTicketActividad}>{actividad.nomActividad}</Tooltip>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <span>{actividad.nomUsuarioResponsable}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className='whitespace-nowrap'>{actividad.fechaInicioProgramado}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className='whitespace-nowrap'>{actividad.fechaFinProgramado}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className='whitespace-nowrap'>{actividad.fechaInicioReal}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className='whitespace-nowrap'>{actividad.fechaFinReal}</span>
                                                                                </td>
                                                                                <td className='whitespace-nowrap'>
                                                                                    {obtenerEstadoActividad(actividad.codEstadoTicketActividad)}
                                                                                </td>

                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })
                                                            })
                                                        )
                                                    : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                            }
                            {
                                vistaProyecto === 6 &&
                                    <section className='w-full h-full p-3 lg:p-0 grid lg:gap-x-0 gap-x-4
                                        grid-cols-[minmax(0,7fr)_minmax(0,3fr)]  lg:grid-cols-1'
                                    >
                                        <section className='flex flex-col'>
                                            <label
                                                className='font-semibold text-[#368ad8d0]'
                                                htmlFor='txtComentarioCierre'
                                            >Comentario de cierre</label>
                                            <textarea
                                                id='txtComentarioCierre'
                                                value={finProyecto.motivoFinalizaDirecto}
                                                className={`${classNameInput} h-[260px] resize-none p-2`}
                                                // onChange={(e) => editarValorFinalizarProyecto('motivoFinalizaDirecto', e.target.value)}
                                            />
                                        </section>
                                        <section className='flex flex-col h-full min-h-0'>
                                            <label className=' text-[#368ad8d0] font-semibold'>Adjunto</label>
                                            <section className='h-full min-h-0 grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1'>
                                                <ContenedorImagen
                                                    envioImagen={envioImagen}
                                                    archivo={imagenes}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                                <ContenedorDocumento
                                                    envioDocumento={envioDoc}
                                                    archivo={documentos}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                            </section>
                                        </section>
                                        
                                    </section>
                            }
                            {
                                vistaProyecto === 7 && 
                                <section className='w-full h-full p-3 lg:p-0 grid lg:gap-x-0 gap-x-4
                                        grid-cols-[minmax(0,7fr)_minmax(0,3fr)]  lg:grid-cols-1'
                                >
                                    <section className='flex flex-col'>
                                        <div 
                                            className={`${inicio.codEstadoTicket == 9 ? 'hidden ' : 'grid '} grid grid-cols-2 col-span-2 gap-x-2`}
                                        >
                                            <label
                                                htmlFor='U.Rechazo'
                                                className='text-[#368ad8d0] font-semibold'
                                            >Uusuario rechazo</label>
                                            <label
                                                htmlFor='U.Rechazo'
                                                className='text-[#368ad8d0] font-semibold'
                                            >Fecha eliminación</label>
                                            <input
                                                className={`w-full lg:text-xs lg:ml-0 px-2 py-1  ${classNameInput}`}
                                                value={inicio.nomUsuarioRechazo}
                                                disabled
                                            />
                                            <input
                                                className={`w-full lg:text-xs lg:ml-0 px-2 py-1  ${classNameInput}`}
                                                value={inicio.fechaHoraRechazo}
                                                disabled
                                            />
                                        </div>
                                        <label
                                            htmlFor='descripcionIdea'
                                            className='text-[#368ad8d0] font-semibold'
                                        >Motivo</label>
                                        <textarea
                                            className={`h-48 lg:text-xs px-2 ${classNameInput} resize-none`}
                                            value={inicio.motivoRechazo}
                                            // onChange={(e)=> editarValorInicioProyecto("motivoRechazo", e.target.value )}
                                            placeholder='Escribir aquí el motivo de rechazo...'
                                            disabled={inicio.codEstadoTicket === 9 ? false : true}
                                        />

                                    </section>
                                    <section className='flex flex-col h-full min-h-0'>
                                        <label className=' text-[#368ad8d0] font-semibold'>Adjunto</label>
                                        <section className='min-h-0 h-full grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1'>
                                            <ContenedorImagen
                                                envioImagen={envioImagen}
                                                archivo={imagenes}
                                                esBloqueo={inicio.codEstadoTicket === 9 ?  false : true}//inicio.codTicket !== 0 ?  true : false}
                                                className={''}
                                            />
                                        </section>
                                    </section>
                                </section>
                            }
                        </section>
                    </section>
                </div>
            </ModalProyecto>
            
            <Modal
                isOpen={isOpenModalDetalleSeguimiento}
                closeModal={closeModalDetalleSeguimiento}
                title={`[${valoresSeguimiento.codTicket}] Detalle seguimiento`}
                validButton={{confirm: false, denied: true}}
            >
                <div className='h-[400px] w-[900px] overflow-y-auto containerScroll lg:w-auto'>
                    <table className='tableResponsive'>
                        <thead>
                            <tr>
                                <th>N</th>
                                <th>COD</th>
                                <th>DESCRIPCIÓN</th>
                                <th className='whitespace-nowrap'>F. REGISTRO</th>
                                <th className='whitespace-nowrap'>U. REGISTRO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                seguimientosTicket.length > 0 ? 
                                    seguimientosTicket.map((det, i) => (
                                        <tr
                                            key={i + 1 }
                                            style={{background: valoresSeguimiento.indice === i + 1 ? '#19692a' : ''}}
                                        >
                                            <td>{i + 1}</td>
                                            <td><span className='bg-blue-500 px-2 rounded'>{det.codTicketSeguimiento}</span></td>
                                            <td>
                                                <input
                                                    key={'input_'+i}
                                                    className={`${classNameInput} bg-transparent border-none px-2`}
                                                    value={det.descripcion}
                                                    onChange={(e) => editarValorSeguimiento(i,'descripcion',e.target.value)}
                                                    onKeyUp={(e)=> e.keyCode === 13 ? registrarSeguimientoTicket(i) : ''}
                                                    enterKeyHint="enter"
                                                />
                                            </td>
                                            <td className='whitespace-nowrap text-center'>{det.fechaCreacion}</td>
                                            <td className='text-center'>{det.nomUsuarioCreacion}</td>
                                            <td className='text-center'>
                                                <i
                                                    className='fa fa-trash text-red-500'
                                                    onClick={async () => {
                                                        const isValid = await eliminarSeguimiento(det.codTicketSeguimiento)
                                                        if(isValid)
                                                        {
                                                            await listarSeguimientoTicket(valoresSeguimiento.codTicket)
                                                            await listarProyectos(tipoProyecto, startDate, endDate)
                                                        }
                                                    }}
                                                ></i>
                                            </td>
                                        </tr>
                                    )) 
                                : 
                                    (esCrearSeguimiento ? '':
                                        <tr>
                                            <td colSpan={6} className='text-center'>No hay información para mostrar...</td>
                                        </tr>
                                    )
                            }
                            {
                                esCrearSeguimiento ?
                                    <tr style={{background: valoresSeguimiento.indice === 0 ? '#19692a' : ''}} key={'tr_crear'}>
                                        <td colSpan={5} className='p-2'>
                                            <input
                                                className={`${classNameInput} px-2 `}
                                                placeholder='Escribir aquí su seguimiento'
                                                onChange={(e )=> editarValorNuevoSeguimiento('descripcion',e.target.value)}
                                                onKeyUp={(e)=> e.keyCode === 13 ? registrarSeguimientoTicket() : ''}
                                                value={nuevoSeguimientoTicket.descripcion}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                className='bg-blue-500 px-2 rounded'
                                                onClick={() => registrarSeguimientoTicket()}
                                            >
                                                <i className='fa fa-paper-plane'></i>
                                            </button>
                                        </td>
                                    </tr>
                                : ''
                            }
                        </tbody>
                    </table>
                </div>
                <div className={` ${esCrearSeguimiento ? ' hidden ' : ' flex '} justify-end py-2`}>
                    <button
                        className=' rounded-[50%] bg-green-500 px-2 py-1'
                        onClick={()=> {
                            if(!esCrearSeguimiento){
                                editarValorNuevoSeguimiento('descripcion','')
                                editarValorNuevoSeguimiento('codTicket',valoresSeguimiento.codTicket)
                                setEsCrearSeguimiento(true)
                                setValoresSeguimiento({indice: 0, codTicket: valoresSeguimiento.codTicket})
                            }
                        }}
                    >
                        <i className='fa fa-plus'></i>
                    </button>
                </div>
            </Modal>

            <Modal
                isOpen={isOpenModalEstados}
                closeModal={closeModalEstados}
                title={`Consolidado de proyectos [${startDate}-${endDate}]`}
                validButton={{confirm: false, denied: true}}
            >
                <div className='h-[650px] w-[990px] items-center grid grid-rows-[minmax(0,5fr) minmax(0,5fr)] gap-1 overflow-y-hidden containerScroll lg:w-auto'>
                    <div>
                        <table className="table ">
                            <thead>
                                <tr key={'fila_1_consolidado'} className="text-xs">
                                    <th rowSpan={2}>ESTADO</th>
                                    <th colSpan={arrayAreas.length}>CANTIDAD PROYECTOS POR AREA</th>
                                    <th rowSpan={2}>TOTAL</th>
                                </tr>
                                <tr key={'fila_2_consolidado'}>
                                    {
                                        arrayAreas.map(area => (
                                            <th>{area.NomArea.toUpperCase()}</th>
                                        ))
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    proyectosAgrupados.length > 0 ?
                                        proyectosAgrupados.map((estado, i) => {
                                            let totalPorEstado = 0;
                                            return(
                                                <tr key={i}>
                                                    <td className="text-left w-[10%]">{primeraLetraMayusculaOracion(estado.nomEstado)}</td>
                                                    {
                                                        arrayAreas.map(area => { 
                                                            totalPorEstado += estado.porArea[area.NomArea.toUpperCase()] || 0;
                                                            return(
                                                                <td key={area.CodArea} className="text-center">
                                                                    {estado.porArea[area.NomArea.toUpperCase()] || 0}
                                                                </td>
                                                            )
                                                        })  
                                                    }
                                                    <td className="text-center">{totalPorEstado}</td>
                                                </tr>
                                            )
                                        })
                                    :
                                        <tr>
                                            <td colSpan={2} className='text-center'>No hay información para mostrar...</td>
                                        </tr>
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={arrayAreas.length + 1 }>TOTAL GENERAL</th>
                                    <th className="text-center">{totalConsolidado}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div className="relative grid gap-1">
                        <div className="flex gap-2 w-full">
                            <button
                                className={`border px-2 rounded-md ${graficoSeleccionado === 'Donut' ? 'bg-blue-500 text-white' : ''}`}
                                onClick={() => setGraficoSeleccionado('Donut')}
                            >
                                <i class="fa-solid fa-chart-pie "></i>
                            </button>
                            <button
                                className={`border px-2 rounded-md ${graficoSeleccionado === 'Bar' ? 'bg-blue-500 text-white' : ''}`}
                                onClick={() => setGraficoSeleccionado('Bar')}
                            >
                                <i class="fa-solid fa-chart-simple "></i>
                            </button>
                        </div>
                        <div className="flex w-full justify-center items-center" style={{ minHeight: '380px'}}>
                            {
                                graficoSeleccionado === 'Donut' ?
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                        <DoughnutProyecto proyectosAgrupados={proyectosAgrupadosTotal} />
                                    </div>
                                :
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                        <BarChartAbexa dataGrafico={dataGrafico} titulo={'Cantidad de Proyectos por Área y Estado'}/>
                                    </div>
                            }
                            {/* <BarChartAbexa dataGrafico={dataGrafico} titulo={'Cantidad de Proyectos por Área y Estado'}/> */}
                        </div>
                    </div>
                    {/* <Doughnut proyectosAgrupados={proyectosAgrupados} /> */}

                </div>

            </Modal>
        </>
    )
}